export default "__VITE_ASSET__V$SZJUwP__"